import { ReactNode } from "react";
import { ButtonEdit } from "main";

import styles from "./Section.module.css";

type SectionProps = {
  title: string;
  children: ReactNode;
  onEditClick?: () => void;
};

export function Section(props: SectionProps) {
  const { children, title, onEditClick } = props;

  return (
    <div className={styles.section}>
      <div
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 24 }}
      >
        <h2 style={{ margin: 0, fontSize: "var(--swing-font-xl) !important" }}>{title}</h2>
        {onEditClick && (
          // avoid button 100% width default
          <div>
            <ButtonEdit onClick={() => onEditClick()} />
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
